"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryType = void 0;
var CategoryType;
(function (CategoryType) {
    CategoryType["ContentCategory"] = "contentcategory";
    CategoryType["Team"] = "team";
    CategoryType["Person"] = "person";
    CategoryType["Site"] = "site";
})(CategoryType = exports.CategoryType || (exports.CategoryType = {}));
